const ActionTypes = {
    VARIANT_CREATE_FAILURE: 'VARIANT_CREATE##FAILURE',
    VARIANT_CREATE_REQUEST: 'VARIANT_CREATE##REQUEST',
    VARIANT_CREATE_SUCCESS: 'VARIANT_CREATE##SUCCESS',
    VARIANT_DELETE_FAILURE: 'VARIANT_DELETE##FAILURE',
    VARIANT_DELETE_REQUEST: 'VARIANT_DELETE##REQUEST',
    VARIANT_DELETE_SUCCESS: 'VARIANT_DELETE##SUCCESS',
    VARIANT_ID_FETCH_FAILURE: 'VARIANT_ID_FETCH##FAILURE',
    VARIANT_ID_FETCH_REQUEST: 'VARIANT_ID_FETCH##REQUEST',
    VARIANT_ID_FETCH_SUCCESS: 'VARIANT_ID_FETCH##SUCCESS',
    VARIANT_UPDATE_FAILURE: 'VARIANT_UPDATE##FAILURE',
    VARIANT_UPDATE_REQUEST: 'VARIANT_UPDATE##REQUEST',
    VARIANT_UPDATE_SUCCESS: 'VARIANT_UPDATE##SUCCESS',
    VARIANTS_FETCH_FAILURE: 'VARIANTS_FETCH##FAILURE',
    VARIANTS_FETCH_REQUEST: 'VARIANTS_FETCH##REQUEST',
    VARIANTS_FETCH_SUCCESS: 'VARIANTS_FETCH##SUCCESS',
} as const

export default ActionTypes
